import type { Dataset } from "@/api";

// Isaac Evaluation 은 시뮬레이션에서 학습한 정책을 시뮬레이션에서 실행하는 평가다. 그래서 담은
// 데이터셋 중 하나라도 시뮬레이션이면 연다. 판정 축은 예약 라벨 `environment` 의 값이고, literal 은
// 데이터셋 필터 프리셋(`datasetFilters.ts` 의 시뮬레이션 데이터)과 같다. "열 수 있는가" 판정은
// 이 파일 한 곳에만 있다.
const ENVIRONMENT_LABEL_KEY = "environment";
export const SIMULATION_ENVIRONMENT = "simulation";

// 열 수 없을 때 잠긴 메뉴 항목이 툴팁으로 표시하는 사유. 판정과 같은 곳에 둔다. 라벨 축이 바뀌면
// 문구도 여기서 함께 바꾼다.
export const ISAAC_EVALUATION_SIMULATION_ONLY_HINT = `Isaac Evaluation은 시뮬레이션 Dataset(${ENVIRONMENT_LABEL_KEY}=${SIMULATION_ENVIRONMENT})이 포함된 Training에서만 설정할 수 있습니다.`;

function isSimulationDataset(dataset: Pick<Dataset, "labels">): boolean {
  return dataset.labels.some(
    (label) => label.key === ENVIRONMENT_LABEL_KEY && label.value === SIMULATION_ENVIRONMENT,
  );
}

export function hasSimulationDataset(datasets: readonly Pick<Dataset, "labels">[]): boolean {
  return datasets.some(isSimulationDataset);
}
